import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { getThumbBySize } from '../../../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../../../constants/image-size-codes';
import { getBasenameFromEntity } from '../../../../../util/role-definitions';

const propTypes = {
  purchasedDigitalBundle: PropTypes.shape({
    id: PropTypes.string,
    photos: PropTypes.shape({
      id: PropTypes.string,
      thumbnail_urls: PropTypes.array,
      album: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
  }),
};

const DigitalBundlePhotoPreview = ({ purchasedDigitalBundle, basename }) => {
  const { photos } = purchasedDigitalBundle;

  return (
    <Fragment>
      <h4 className="text-center">Previewing Digital Bundle photos</h4>
      <p className="text-center">
        You can click on the photos below to open a larger version on a new tab
      </p>
      <div className="card-photo-selection-control-scroll">
        <div className="card-photo-selection-control-photo-list">
          {(photos?.records ?? []).map(bundlePhoto => {
            const { photo } = bundlePhoto;
            const { album, albums } = photo;
            const targetAlbum = album ?? albums?.records?.[0];

            return (
              <a
                className="digital-bundle-preview-photo-select"
                target="_blank"
                rel="noopener noreferrer"
                href={`/app/${
                  getBasenameFromEntity(targetAlbum) ?? basename
                }/albums/${targetAlbum?.id}/photos/${photo?.id}`}
              >
                <img
                  src={
                    getThumbBySize(
                      photo.thumbnail_urls,
                      IMAGE_SIZE_CODE.LARGE2X,
                    )?.url
                  }
                  alt=""
                />
                <p className="text-xs text-center text-light text-nowrap text-truncate">
                  {photo.original_filename}
                </p>
              </a>
            );
          })}
        </div>
      </div>
    </Fragment>
  );
};

DigitalBundlePhotoPreview.propTypes = propTypes;

export default DigitalBundlePhotoPreview;
